import axios from 'axios';
import axiosRetry from 'axios-retry';
import LocalStorage from 'store';
import moment from 'moment-timezone';
import Bowser from 'bowser';

const Axios = axios.create({
  baseURL: process.env.VUE_APP_URL_MENU_DIGITAL,
  withCredentials: false
});

axiosRetry(Axios, { retries: 1 });
Axios.interceptors.request.use((request) => {
  if (LocalStorage.get('_token')) {
    request.headers.Authorization = 'Bearer ' + LocalStorage.get('_token');
  }
  if (request.data && !request.headers['Content-Type']) {
    request.headers.Accept = 'application/json';
    request.headers['Content-Type'] = 'application/json';
    request.data = JSON.stringify(request.data);
  }
  return request;
});
Axios.interceptors.response.use(undefined, err => {
  const res = err.response;
  if (res.status === 401 && res.config && !res.config.__isRetryRequest) {
    LocalStorage.clearAll();
    return Promise.reject(err);
  }
  if (res.status === 403) {
    return Promise.reject(err);
  }
});

function metrics (action = null, language = 'spanish', id = null) {
  try {
    const bowser = Bowser.getParser(window.navigator.userAgent);
    const obj = {
      vendorId: localStorage.getItem('_id'),
      ip: '',
      path: window.location.pathname,
      fullPath: window.location.href,
      city: '',
      country: '',
      language: language,
      domain: window.location.hostname,
      userId: localStorage.getItem('_user') ? localStorage.getItem('_user') : null,
      browser: bowser.getBrowserName(),
      device: bowser.getPlatformType(),
      system: bowser.getOSName(),
      systemVersion: bowser.getOSVersion() === undefined ? null : bowser.getOSVersion(),
      visitDate: moment().format('YYYY-MM-DD hh:mm'),
      source: 'qr',
      date: ''
    };
    if (action != null) {
      obj.action = action;
    }
    if (id != null) {
      obj.actionId = id;
    }
    if (language !== 'spanish') {
      obj.language = language;
    }
    Axios.post('/analytics/navigator', obj);
  } catch (e) {
    console.warn('Error', e);
  }
}

function menuMetrics (source = null, origin = null, utm = {}) {
  try {
    const bowser = Bowser.getParser(window.navigator.userAgent);
    const obj = {
      vendorId: localStorage.getItem('_id'),
      ip: '',
      browser: bowser.getBrowserName(),
      device: bowser.getPlatformType(),
      system: bowser.getOSName(),
      systemVersion: bowser.getOSVersion() === undefined ? null : bowser.getOSVersion(),
      date: moment().format('YYYY-MM-DD'),
      datetime: moment().format('YYYY-MM-DD hh:mm'),
      source,
      origin,
      utmInfo: Object.keys(utm).length > 0 ? utm : null
    };
    Axios.post('/analytics/navigator/menu', obj);
  } catch (e) {
    console.warn('Error', e);
  }
}

export {
  metrics,
  menuMetrics
};
